<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="500">
    <template v-slot:title>{{ title }}</template>
    <v-row>
      <v-col>
        <v-text-field
          v-model="name"
          label="Name"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model="purchaseNominalCode"
          label="Purchase Nominal Code"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model="salesNominalCode"
          label="Sales Nominal Code"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          type="number"
          min="1"
          v-model.number="stdOccupancy"
          label="Std Occupancy"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          type="number"
          min="1"
          v-model.number="minOccupancy"
          :outlined="outlinedInputs"
          label="Min Occupancy"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          type="number"
          min="1"
          v-model.number="maxOccupancy"
          :outlined="outlinedInputs"
          label="Max Occupancy"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <tax-list-select
          v-model="taxCode"
          :outlined="outlinedInputs"
        ></tax-list-select>
      </v-col>
      <v-col sm="4">
        <v-checkbox
          label="No Report"
          v-model="hidden"
          primary
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col>
        <v-switch v-model="notInUse" label="Not In Use"></v-switch>
      </v-col>
    </v-row>

    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <v-row v-if="debug">
      <code>{{ value }}</code>
    </v-row>
  </basic-dialog>
</template>

<script>
import BasicEditDialog from "../../../../mixins/BasicEditDialog";
import TaxListSelect from "../../shared/TaxesListSelect";
export default {
  name: "other-type-edit-dialog",
  props: {
    itemTypeLabel: {
      type: String,
      default: () => "Other Type",
    },
  },

  mixins: [BasicEditDialog],

  components: { TaxListSelect },

  data() {
    return {
      debug: false,
      name: this.value ? this.value.name : "",
      purchaseNominalCode: this.value ? this.value.purchaseNominalCode : "",
      salesNominalCode: this.value ? this.value.salesNominalCode : "",
      maxOccupancy: this.value ? this.value.maxOccupancy : 999,
      minOccupancy: this.value ? this.value.minOccupancy : 1,
      stdOccupancy: this.value ? this.value.stdOccupancy : 1,
      taxCode: this.value ? this.value.taxCode : "",
      hidden:
        this.value && this.value.hidden != null ? this.value.hidden : false,
      notInUse: this.value ? this.value.notInUse : false,
    };
  },

  computed: {
    isValid() {
      return this.name && this.name != "";
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        id: this.value && this.value.id ? this.value.id : undefined,
        name: this.name,
        purchaseNominalCode: this.purchaseNominalCode,
        salesNominalCode: this.salesNominalCode,
        stdOccupancy: this.stdOccupancy,
        minOccupancy: this.minOccupancy,
        maxOccupancy: this.maxOccupancy,
        taxCode: this.taxCode,
        hidden: this.hidden,
        notInUse: this.notInUse,
      });
    },
  },

  watch: {
    value(newVal) {
      this.name = newVal.name;
      this.purchaseNominalCode = newVal.purchaseNominalCode;
      this.salesNominalCode = newVal.salesNominalCode;
      this.maxOccupancy = newVal.maxOccupancy;
      this.minOccupancy = newVal.minOccupancy;
      this.stdOccupancy = newVal.stdOccupancy;
      this.taxCode = newVal.taxCode;
      this.hidden = newVal.hidden != null ? newVal.hidden : false;
      this.notInUse = newVal.notInUse;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/service-types/OtherTypeEditDialog.vue